import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { useHistory } from "react-router-dom";

import { Card, TextField } from "@mui/material";

/* import "../styles/main.css"; */
import {
  SCSGenericButton,
  SCSLoadingButton,
} from "app/modules/common/components/Buttons/SCSButtons";
import {
  StyleInputs,
  StylesCardBuscador,
} from "app/modules/common/styles/themes";

const BuscadorMovimientos = ({ setDatosBusqueda, titulo }) => {
  const navigate = useHistory();

  const redirectHomePage = () => {
    navigate.push("/initialHome");
  };

  const enviarDatosBusqueda = (valores) => {
    /* console.log(valores); */
    setDatosBusqueda((args) => ({
      ...args,
      identificacion: valores.identificacion,
      mostrarBuscador: false,
    }));
  };

  return (
    <div div className="buscador-siniestros-container">
      <Card sx={StylesCardBuscador()}>
        <header className="header-colaborador-header">
          <div className="buscador-movimientos-titulo">
            <h2>{titulo}</h2>
          </div>

          <Formik
            initialValues={{
              identificacion: "",
            }}
            validationSchema={Yup.object({
              identificacion: Yup.string().required("Identificación requerida"),
            })}
            onSubmit={(valores, { setSubmitting }) => {
              enviarDatosBusqueda(valores);
            }}
          >
            {({ values, handleChange, touched, errors, handleBlur }) => (
              <Form>
                <div className="buscador-movimientos-opciones">
                  <div className="buscador-movimientos-opciones__inputs">
                    <TextField
                      required
                      id="identificacion"
                      name="identificacion"
                      type="text"
                      label="Identificación"
                      sx={StyleInputs(60, 100)}
                      //sx={{ width: "100%" }}
                      value={values.identificacion}
                      onChange={handleChange}
                      size="small"
                      error={
                        touched.identificacion && Boolean(errors.identificacion)
                      }
                      helperText={
                        touched.identificacion && errors.identificacion
                      }
                      onBlur={handleBlur}
                    />
                  </div>

                  <div className="buscador-movimientos-opciones__buttons">
                    <SCSLoadingButton size={45} titulo="Buscar" />

                    <SCSGenericButton
                      size={45}
                      titulo="Cancelar"
                      onClick={redirectHomePage}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </header>
      </Card>
    </div>
  );
};

export default BuscadorMovimientos;
